export class DecoratorResult {
    _mutations = [];
    addMutation(mutation) {
        this._mutations.push(mutation);
    }
    get mutations() {
        return this._mutations;
    }
}
//# sourceMappingURL=decorator-result.js.map